export default __webpack_public_path__ + "static/media/bh-ico-active.dc173680.svg";